import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { FournisseurRetours, FournisseurTheme } from '@journal/ui';
import { App } from './App.tsx';
import { FournisseurSession } from './lib/session.tsx';
import './styles/index.css';

const racine = document.getElementById('racine');
if (!racine) throw new Error("L'élément racine est introuvable");

createRoot(racine).render(
  <StrictMode>
    {/*
      * Ordre des fournisseurs, du plus stable au plus volatil.
      *
      * Thème et densité ne dépendent de rien : ils s'appliquent même à l'écran
      * de connexion. Les retours d'action viennent ensuite, parce que la
      * session doit pouvoir notifier une déconnexion. Le routage est le plus
      * interne : lui seul change à chaque navigation.
      */}
    <FournisseurTheme>
        <FournisseurRetours>
          <FournisseurSession>
            {/* Le serveur renvoie index.html sur toute adresse hors /api : les
                liens profonds des courriels survivent au rechargement. */}
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </FournisseurSession>
        </FournisseurRetours>
    </FournisseurTheme>
  </StrictMode>,
);
